import type { Winner } from '@src/@types/ozonPrizeWinners';
import { HeaderTitle } from '@src/components/OctoberPrizeDraw/HeaderTitle';
import { OctoberPrizeDrawLayout } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawLayout';
import { WinnerBlock } from '@src/components/OctoberPrizeDraw/OctoberPrizeResult/components/WinnerBlock';

import styles from './styles.module.scss';

type Props = {
  currentWinner: Winner | null;
};

const NO_WINNER = {
  title: 'Вашего номера нет в списке победителей',
  subTitle: 'Проверьте правильность ввода или введите другой номер',
};

export const OctoberPrizeResult = ({ currentWinner }: Props) => (
  <OctoberPrizeDrawLayout>
    {currentWinner ? (
      <WinnerBlock currentWinner={currentWinner} />
    ) : (
      <HeaderTitle className={styles.headingWrapper} title={NO_WINNER.title} subTitle={NO_WINNER.subTitle} />
    )}
  </OctoberPrizeDrawLayout>
);
